// extracted by mini-css-extract-plugin
module.exports = {"first_item_in_group":"first_item_in_group-ix86p","last_item_in_group":"last_item_in_group-lkQY8"};